import { render, staticRenderFns } from "./ReplyAudit.vue?vue&type=template&id=6c809a9a&scoped=true&"
import script from "./ReplyAudit.vue?vue&type=script&lang=js&"
export * from "./ReplyAudit.vue?vue&type=script&lang=js&"
import style0 from "./ReplyAudit.vue?vue&type=style&index=0&id=6c809a9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c809a9a",
  null
  
)

export default component.exports